<template>
  <b-container fluid>
     <b-alert v-model="showTop" placement="top" duration="3000" type="danger" width="400px" dismissable>
        <span class="icon-info-circled alert-icon-float-left"></span>
        <strong>{{ $t('LNG_ERROR', this.lang) }}</strong>
        <p>{{ $t('LNG_TEST_NOT_DELETED', this.lang) }}</p>
     </b-alert>
     <b-row>
       <b-col cols="12">
         <h3>{{ $t('LNG_MAINVIEW_TITLE', this.lang) }}</h3>
       </b-col>
     </b-row>
     <b-row>
       <b-col cols="10" offset="1">
          <div id="tests">
            <v-client-table :data="testData" :columns="testsColumns" :options="testsOptions">
               <div slot="editTest"   slot-scope="props" class="fa fa-edit"      v-on:click="editATest(props.row.id)"    style="cursor: pointer;"></div>
               <div slot="deleteTest" slot-scope="props" class="fa fa-trash"     v-on:click="deleteATest(props.row.id)"  style="cursor: pointer;" v-if="props.row.shared !== 1"></div>
               <div slot="wordButton" slot-scope="props" class="fa fa-file"      v-on:click="openWord(props.row.id)"     style="cursor: pointer;" v-if="props.row.word"></div>
               <div slot="pdfButton"  slot-scope="props" class="fa fa-paperclip" v-on:click="openPdf(props.row.id)"      style="cursor: pointer;" v-if="props.row.pdf"></div>
               <div slot="share"      slot-scope="props" class="fa fa-share-alt" v-on:click="openShareBox(props.row.id)" style="cursor: pointer;" v-if="props.row.shared !== 1"></div>
            </v-client-table>
          </div>
        </b-col>
     </b-row>
     <b-modal v-model="fileModalNewTest" effect="fade" @shown="setModalInputFocus" :title="$t('LNG_NEW_TEST', this.lang)">
         <b-alert show variant="danger" v-if="showMissingDataError">{{this.missingDataErrorMsg}}</b-alert>
         <b-form-input v-model="testName" type="text" ref="testName" required :placeholder="$t('LNG_NAME', this.lang)" class="mb-3"></b-form-input>
         <b-form-input v-model="testDate" type="date" :placeholder="$t('LNG_DATE', this.lang)" class="mb-3"></b-form-input>
         <b-form-select v-model="selectDiscipline.value" :options="selectDiscipline.options" class="mb-3">
           <template slot="first">
              <option :value="null" disabled>-- {{$t('LNG_SELECT_DISCIPLINE_DEFAULT', this.lang)}} --</option>
           </template>
         </b-form-select>
         <b-form-select multiple v-model="selectTestGroup.value" :options="selectTestGroup.options" class="mb-3"></b-form-select>
         <b-form-textarea rows="5" v-model="comment" id="comment" :placeholder="$t('LNG_TEST_COMMENTS', this.lang)"></b-form-textarea>
         
         <div slot="modal-footer">
           <b-button type="button" v-on:click.prevent="exitFileModalNewTest()">{{ $t('LNG_CLOSE', lang) }}</b-button>
           <b-button variant="evaobj" type="button" v-on:click.prevent="createNewTest($event)">{{ $t('LNG_CREATE', lang) }}</b-button>
         </div>
      </b-modal>
      
      <!-- A REVOIR LE DESIGN -->
      <b-modal v-model="fileModalShareTest" effect="fade">
        <div class="alert alert-danger" role="alert" v-if="showErrorSharedStatusChange">
          {{ $t('LNG_ERROR_UPDATING_SHARING_STATUS', this.lang) }}
        </div>
        <div slot="modal-header" class="modal-header">
          <h4 class="modal-title">
             <b>{{ $t('LNG_MANAGE_SHARING', this.lang) }}</b>
          </h4>
        </div>
        <v-client-table :data="teacherSharedData" :columns="teacherSharedColumns" :options="teacherSharedOptions">
          <div slot="shared" slot-scope="props" class="fa" v-bind:class="{'fa-check': props.row.shared === '1', 'fa-minus-circle': (props.row.shared === null || props.row.shared === '0')}" v-on:click="changeSharedStatus(props.row.id)" style="cursor: pointer;"></div>
          <div slot="can_edit" slot-scope="props" class="fa" v-if="props.row.shared === '1'" v-show="false"><b-form-checkbox v-model="canEditArray[props.row.id]" v-on:change="editModeClicked(props.row.id)"/></div>
        </v-client-table>        
        <div slot="modal-footer" class="modal-footer">
          <button type="button" class="btn btn-default" v-on:click.prevent="exitModalShareTest()">{{ $t('LNG_CLOSE', this.lang) }}</button>
        </div>
      </b-modal>
      
      <!-- A REVOIR LE DESIGN -->
      <b-alert v-model="showAlertNoLicence" placement="top" duration="3000" type="danger" width="400px" dismissable>
        <span class="icon-ok-circled alert-icon-float-left"></span>
        <strong>{{ $t('LNG_WARNING_VERSION', this.lang) }}</strong>
        <p>{{ $t('LNG_YOU_USE_THE_FREE_VERSION', this.lang) }}</p>
      </b-alert>
      
      <b-modal :title="$t('LNG_CONFIRM_TEST_DELETION', this.lang)" v-model="showDeleteModal" @ok="okDeleteTestAction" @cancel="cancelAction" :cancel-title="$t('LNG_CANCEL', this.lang)" ok-variant="evaobj" :ok-title="$t('LNG_DELETE', this.lang)">
      {{ $t('LNG_DO_YOU_REALLY_WANT_TO_DELETE_THE_TEST', this.lang) }}
      </b-modal>
      
      <b-modal v-model="fileModalStudents" :title="$t('LNG_SEND_A_FILE', this.lang)" size="lg">
        <b-alert variant="danger" v-model="displayStudentImportAlert">
            {{ $t('LNG_STUDENT_IMPORT_WARNING', this.lang, {importedStudents: this.importedStudents}) }} <br/>
            {{ $t('LNG_STUDENT_IMPORT_ERRORMESSAGE', this.lang,  {errorMessage: this.errorMessage}) }}
        </b-alert>
        <b-alert variant="warning" v-model="displayStudentImportWarning">
            {{ $t('LNG_STUDENT_IMPORT_WARNING', this.lang, {importedStudents: this.importedStudents}) }} <br/>
            {{ $t('LNG_STUDENT_IMPORT_ERRORMESSAGE', this.lang, {errorMessage: this.errorMessage}) }}
         </b-alert>
         <b-alert variant="success" v-model="displayStudentImportSuccess">
           {{ $t('LNG_STUDENT_IMPORT_SUCCESS', this.lang, {number: this.importedStudents})}}
        </b-alert>
        
        <p class="text-left"><b-form-checkbox v-model="studentFileHasHeader" value="1">{{ $t('LNG_STUDENT_SEND_A_FILE_WITH_HEADER', this.lang) }}</b-form-checkbox></p>
        
        <p class="text-left">{{ $t('LNG_STUDENT_FILE_DESCRIPTION', this.lang) }}</p>
        
        <b-form-file accept=".csv" v-model="studentFile" :state="Boolean(studentFile)" ref="fileinput" :placeholder="$t('LNG_FILE', lang)" required />
        
        <div slot="modal-footer">
          <b-button type="button" v-on:click.prevent="exitFileModalStudents()">{{ $t('LNG_CLOSE', lang) }}</b-button>
          <b-button variant="evaobj" type="button" v-on:click.prevent="sendFileStudents($event)">{{ $t('LNG_CREATE', lang) }}</b-button>
        </div>
      </b-modal>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
// const constDateFormat = 'DD.MM.YYYY'
export default {
  name: 'mainview',
  components: {
  },
  data () {
    return {
      displayStudentImportAlert: false,
      displayStudentImportWarning: false,
      displayStudentImportSuccess: false,
      importedStudents: 0,
      errorMessage: '',
      studentFileHasHeader: 0,
      selectedTest: 0,
      canEditArray: [],
      showMissingDataError: false,
      missingDataErrorMsg: '',
      showErrorSharedStatusChange: false,
      showTop: false,
      fileModalShareTest: false,
      fileModalStudents: false,
      fileModalNewTest: false,
      testName: '',
      testDate: '',
      testDiscipline: '',
      testComment: '',
      dateValue: '',
      format: 'd.M.yyyy',
      clear: true,
      selected: null,
      testData: [],
      comment: '',
      selectDiscipline: {
        options: [],
        value: null
      },
      selectTestGroup: {
        options: [],
        value: []
      },
      testsColumns: ['date', 'discipline', 'name', 'groups', 'comments', 'editTest', 'deleteTest', 'wordButton', 'pdfButton'],
      testsOptions: {
        headings: {
          date: this.$t('LNG_DATE', this.lang),
          discipline: this.$t('LNG_DISCIPLINE', this.lang),
          name: this.$t('LNG_NAME', this.lang),
          groups: this.$t('LNG_GROUPS', this.lang),
          comments: this.$t('LNG_COMMENTS', this.lang),
          editTest: '',
          deleteTest: '',
          wordButton: this.$t('LNG_WORD', this.lang),
          pdfButton: this.$t('LNG_PDF', this.lang)
        },
        filterByColumn: true,
        perPage: 1000,
        perPageValues: [10, 25, 50, 100, 250, 500, 1000],
        texts: this.$parent.tableTexts,
        sortIcon: { base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down', is: 'glyphicon-sort' },
        filterable: ['date', 'discipline', 'name', 'groups', 'comments'],
        sortable: ['date', 'discipline', 'name', 'groups', 'comments']
      },
      teacherSharedData: [],
      teacherSharedColumns: ['name', 'firstname', 'shared', 'can_edit'],
      teacherSharedOptions: {
        headings: {
          name: this.$t('LNG_NAME_TEACHER', this.lang),
          firstname: this.$t('LNG_FIRSTNAME', this.lang),
          // email: this.$t('LNG_EMAIL', this.lang),
          shared: '',
          can_edit: this.$t('LNG_EDITABLE', this.lang)
        },
        filterByColumn: true,
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100, 250, 500, 1000],
        texts: this.$parent.tableTexts,
        sortIcon: { base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down', is: 'glyphicon-sort' },
        filterable: ['name', 'firstname', 'email'],
        sortable: ['name', 'firstname', 'shared']
      },
      showDeleteModal: false,
      testToDelete: 0,
      showAlertNoLicence: false,
      studentFile: null
    }
  },
  mounted: function () {
    // Texte particulier pour la table
    this.loadDisciplineGroups()
    this.getTestList()
    moment.locale('fr-ch')
    this.$parent.spinner = false
  },
  computed: {
    ...mapState([
      'api',
      'fullname',
      'lang'
    ]),
    adminLevel () {
      return this.$store.getters.adminLevel
    }
  },
  methods: {
    setModalInputFocus (event) {
      this.$refs.testName.focus()
    },
    editModeClicked: function (id) {
      // Change the canEdit in the db
      // TODO à vérifier lors de l'activation du partage
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'setTestSharingEditMode',
          can_edit: this.canEditArray[id],
          test: this.selectedTest,
          teacher: id
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {

      })
    },
    changeSharedStatus: function (itemId) {
      // TODO à vérifier lors de l'activation du partage
      this.showErrorSharedStatusChange = false
      var newStatus
      var testId
      this.teacherSharedData.forEach(function (sharing) {
        if (sharing.id === itemId) {
          testId = sharing.test
          if (sharing.shared === '1') {
            newStatus = '0'
          } else {
            newStatus = '1'
          }
        }
      })
      // Change the status in the db
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'setTestSharingStatus',
          status: newStatus,
          test: testId,
          teacher: itemId,
          can_edit: this.canEditArray[itemId]
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          this.teacherSharedData.forEach(function (sharing) {
            if (sharing.id === itemId) {
              sharing.shared = newStatus
            }
          })
        } else {
          this.showErrorSharedStatusChange = true
        }
      })
    },
    loadShareTeacherData: function (testId) {
      // TODO à vérifier lors de l 'activation du partage
      this.selectedTest = testId
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'loadTeacherShared',
          test: testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.teacherSharedData = response.data.teachers
        this.teacherSharedData.forEach(function (element) {
          if (element.can_edit === '1') {
            this.canEditArray[element.id] = 1
          }
        }, this)
      })
    },
    openShareBox: function (testId) {
      // TODO à vérifier lors de l 'activation du partage
      if (this.$store.getters.licence === '1') {
        this.loadShareTeacherData(testId)
        this.showErrorSharedStatusChange = false
        this.fileModalShareTest = !this.fileModalShareTest
      } else {
        this.showAlertNoLicence = true
      }
    },
    exitModalShareTest: function () {
      // TODO à vérifier lors de l 'activation du partage
      this.selectedTest = 0
      this.fileModalShareTest = !this.fileModalShareTest
    },
    getTestList: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getTestList'
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.testData = response.data.tests
        this.testData.forEach(function (element) {
          if (moment(element.date).isValid()) {
            element.date = moment(element.date).format('DD.MM.YYYY')
          }
        })
      })
    },
    createNewTest: function (data) {
      if (this.testName.length === 0) {
        this.showMissingDataError = true
        this.missingDataErrorMsg = this.$t('LNG_MISSING_TEST_NAME', this.lang)
        return
      }
      if (this.testDate.length === 0) {
        this.showMissingDataError = true
        this.missingDataErrorMsg = this.$t('LNG_TEST_MISSING_DATE', this.lang)
        return
      }
      if (this.selectDiscipline.value === null) {
        this.showMissingDataError = true
        this.missingDataErrorMsg = this.$t('LNG_TEST_MISSING_DISCIPLINE', this.lang)
        return
      }
      if (this.selectTestGroup.value.length === 0) {
        this.showMissingDataError = true
        this.missingDataErrorMsg = this.$t('LNG_TEST_MISSING_GROUPS', this.lang)
        return
      }
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'createTest',
          name: this.testName,
          date: this.testDate,
          discipline: this.selectDiscipline.value,
          groups: this.selectTestGroup.value,
          comment: this.comment
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.fileModalNewTest = !this.fileModalNewTest
        this.testName = ''
        this.testDate = ''
        this.selectDiscipline.value = null
        this.selectTestGroup.value = []
        this.comment = ''
        this.getTestList()
      })
    },
    loadDisciplineGroups: function (data) {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getDisciplineAndGroup'
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        while (this.selectDiscipline.options.length > 0) {
          this.selectDiscipline.options.pop()
        }
        while (this.selectTestGroup.options.length > 0) {
          this.selectTestGroup.options.pop()
        }
        response.data.disciplines.forEach((e) => {
          this.selectDiscipline.options.push({text: e.name + ' ' + e.level, value: e.id})
        })
        response.data.groups.forEach((e) => {
          this.selectTestGroup.options.push({text: e.name, value: e.id})
        })
      })
    },
    exitFileModalNewTest: function (data) {
      this.showMissingDataError = false
      this.fileModalNewTest = !this.fileModalNewTest
    },
    editATest: function (id) {
      this.$router.push({ path: '/testEdit/' + id })
    },
    deleteATest: function (id) {
      // Demander une validation
      this.testToDelete = id
      this.showDeleteModal = true
    },
    okDeleteTestAction () {
      this.showDeleteModal = false
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'deleteATest',
          id: this.testToDelete
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          var i = 0
          console.log(this.testToDelete)
          for (i = 0; i < this.testData.length; i++) {
            if (this.testData[i].id === this.testToDelete) {
              this.testData.splice(i, 1)
            }
          }
          this.testToDelete = 0
        } else {
          this.showTop = true
        }
      })
    },
    openPdf: function (id) {
      window.open(this.api + '?method=openPdfTestFile&id=' + id)
    },
    openWord: function (id) {
      window.open(this.api + '?method=openWordTestFile&id=' + id)
    },
    cancelAction () {
      this.showDeleteModal = false
    },
    openFileModelStudents: function () {
      this.fileModalStudents = !this.fileModalStudents
    },
    exitFileModalStudents: function (data) {
      this.displayStudentImportWarning = false
      this.displayStudentImportAlert = false
      this.displayStudentImportSuccess = false
      this.$refs.fileinput.reset()
      this.fileModalStudents = !this.fileModalStudents
      this.$emit('closeModal', this.fileModalStudents)
    },
    showAddTest: function () {
      this.fileModalNewTest = !this.fileModalNewTest
    },
    sendFileStudents: function (event) {
      event.preventDefault()
      this.displayStudentImportWarning = false
      this.displayStudentImportAlert = false
      this.displayStudentImportSuccess = false
      this.errorMessage = ''
      this.$parent.spinner = true
      this.formData = new FormData()
      this.formData.append('method', 'uploadFile')
      this.formData.append('import_file', this.studentFile, this.studentFile.name)
      this.axios({
        method: 'post',
        url: this.api + '?method=uploadFileStudents&studentFileHasHeader=' + this.studentFileHasHeader,
        data: this.formData,
        headers: {'Content-Type': 'multipart/form-data'}
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            this.$parent.spinner = false

            if (response.data.errors.length > 0 && response.data.numberOfImported === 0) { // ALERT
              this.displayStudentImportWarning = false
              this.displayStudentImportAlert = true
              this.displayStudentImportSuccess = false
              response.data.errors.forEach((e) => {
                this.errorMessage += e + ' '
              })
            } else if (response.data.errors.length > 0 || response.data.numberOfImported === 0) { // WARNING
              this.displayStudentImportWarning = true
              this.displayStudentImportAlert = false
              this.displayStudentImportSuccess = false
              response.data.errors.forEach((e) => {
                this.errorMessage += e + ' '
              })
            } else {
              this.displayStudentImportWarning = false
              this.displayStudentImportAlert = false
              this.displayStudentImportSuccess = true
            }
            this.importedStudents = response.data.numberOfImported
          } else {
            this.$root.$emit('spinner::hide')
            this.displayStudentImportWarning = false
            this.displayStudentImportAlert = true
            this.displayStudentImportSuccess = false
          }
        }
        this.$root.$emit('spinner::hide')
        this.loadDisciplineGroups()
      })
      .catch(function (error) {
        console.log(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style>
</style>



// WEBPACK FOOTER //
// mainview.vue?69ace4e2